var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCourse04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 83,
    viewBox: "0 0 111 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_158_19)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.68 41.0046C25.5968 39.5573 27.1907 38.6802 28.9039 38.6802H77.8521C79.3121 38.6802 80.6991 39.3183 81.6491 40.427L94.929 55.927C97.708 59.1706 95.4032 64.1802 91.132 64.1802H19.0858C15.1451 64.1802 12.7532 59.8337 14.8619 56.5046L24.68 41.0046Z",
    fill: "#0DD3A3"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.3418 40.5189L31.3363 40.6241H31.4417H49.4266C49.851 40.6241 50.1944 40.9676 50.1944 41.3919C50.1944 41.8163 49.851 42.1598 49.4266 42.1598H30.5513C30.1269 42.1598 29.7835 41.8163 29.7835 41.3919C29.7835 31.4208 37.8963 23.308 47.8686 23.308C50.6099 23.308 53.2431 23.9058 55.6953 25.0847C56.0772 25.2685 56.2384 25.7277 56.0547 26.1095C55.871 26.4912 55.4112 26.6516 55.0297 26.4688C52.7864 25.3902 50.377 24.8437 47.8686 24.8437C39.0361 24.8437 31.7976 31.7982 31.3418 40.5189Z",
    fill: "black",
    stroke: "#0D0D0D",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9788 10.9703C57.9788 16.7116 53.3067 21.3832 47.5642 21.3832C41.8247 21.3832 37.1542 16.7117 37.1542 10.9703C37.1542 5.22901 41.8241 0.558008 47.5642 0.558008C53.3067 0.558008 57.9788 5.22905 57.9788 10.9703ZM56.4432 10.9703C56.4432 6.07547 52.4602 2.09367 47.5642 2.09367C42.6705 2.09367 38.6899 6.07552 38.6899 10.9703C38.6899 15.8651 42.6705 19.8476 47.5642 19.8476C52.4602 19.8476 56.4432 15.8658 56.4432 10.9703Z",
    fill: "black",
    stroke: "#0D0D0D",
    strokeWidth: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76.808 30.2673V30.3673H76.908H81.2471C81.6715 30.3673 82.0149 30.7108 82.0149 31.1352V53.1202C82.0149 53.5446 81.6715 53.888 81.2471 53.888H54.0551C53.6307 53.888 53.2873 53.5446 53.2873 53.1202V31.1352C53.2873 30.7108 53.6307 30.3673 54.0551 30.3673H70.5439H70.6439V30.2673V24.1925C70.6439 23.7681 70.9873 23.4247 71.4117 23.4247H76.0401C76.4645 23.4247 76.808 23.7681 76.808 24.1925V30.2673ZM72.2795 24.9604H72.1795V25.0604V36.0529V36.1529H72.2795H75.1723H75.2723V36.0529V25.0604V24.9604H75.1723H72.2795ZM70.6439 32.003V31.903H70.5439H54.9229H54.8229V32.003V45.8883V45.9883H54.9229H80.3793H80.4793V45.8883V32.003V31.903H80.3793H76.908H76.808V32.003V36.9207C76.808 37.3451 76.4645 37.6885 76.0401 37.6885H71.4117C70.9873 37.6885 70.6439 37.3451 70.6439 36.9207V32.003ZM54.8229 52.2524V52.3524H54.9229H80.3793H80.4793V52.2524V47.624V47.524H80.3793H54.9229H54.8229V47.624V52.2524Z",
    fill: "black",
    stroke: "#0D0D0D",
    strokeWidth: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2047 34.6884H65.6261C65.2017 34.6884 64.8583 34.345 64.8583 33.9206C64.8583 33.4962 65.2017 33.1527 65.6261 33.1527H66.2047C66.6291 33.1527 66.9725 33.4962 66.9725 33.9206C66.9725 34.345 66.6291 34.6884 66.2047 34.6884Z",
    fill: "black",
    stroke: "#0D0D0D",
    strokeWidth: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2047 38.7382H65.6261C65.2017 38.7382 64.8583 38.3948 64.8583 37.9704C64.8583 37.546 65.2017 37.2025 65.6261 37.2025H66.2047C66.6291 37.2025 66.9725 37.546 66.9725 37.9704C66.9725 38.3948 66.6291 38.7382 66.2047 38.7382Z",
    fill: "black",
    stroke: "#0D0D0D",
    strokeWidth: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8405 34.6884H59.262C58.8376 34.6884 58.4942 34.345 58.4942 33.9206C58.4942 33.4962 58.8376 33.1527 59.262 33.1527H59.8405C60.2649 33.1527 60.6084 33.4962 60.6084 33.9206C60.6084 34.345 60.2649 34.6884 59.8405 34.6884Z",
    fill: "black",
    stroke: "#0D0D0D",
    strokeWidth: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8405 38.7382H59.262C58.8376 38.7382 58.4942 38.3948 58.4942 37.9704C58.4942 37.546 58.8376 37.2025 59.262 37.2025H59.8405C60.2649 37.2025 60.6084 37.546 60.6084 37.9704C60.6084 38.3948 60.2649 38.7382 59.8405 38.7382Z",
    fill: "black",
    stroke: "#0D0D0D",
    strokeWidth: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_158_19",
    x: 0.0777588,
    y: 28.6802,
    width: 110.064,
    height: 53.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.458333 0 0 0 0 0.458333 0 0 0 0 0.458333 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_158_19"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_158_19",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourse04);
export default __webpack_public_path__ + "static/media/course-04.8ad2a3ed0f89d5ed15d9cae5dfae0c0e.svg";
export { ForwardRef as ReactComponent };